import React from 'react'
import { Link } from 'react-router-dom'
import { useSEO } from '../hooks/useSEO'
import { SITE_INFO } from '../data/siteData'
import { useCMSSide } from '../hooks/useCMS'

export function AfbudspolitikPage() {
  const { side: cmsSide } = useCMSSide('afbudspolitik')

  useSEO({
    title: cmsSide?.seo_titel || 'Afbudspolitik | BoSteendahl.dk',
    description: cmsSide?.seo_beskrivelse || 'Meld afbud så tidligt som muligt, og senest kl. 8 dagen før aftalt tid. Læs de gældende regler for afbud og udeblivelse hos Bo Steendahl.',
    ogImage: cmsSide?.dele_billede?.[0] || 'https://assets.auxodev.dk/assets/2a253654-8b0d-44c3-813e-14453c64ff7c/logo-11-dec.png',
  })

  return (
    <div className="bg-[#FAF8F5]">
      {/* Hero Section */}
      <section className="relative py-16 lg:py-20 bg-gradient-to-b from-[#F5EFE9] to-[#FAF8F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#1b3a4b]/8 text-[#1b3a4b] text-xs font-semibold uppercase tracking-wider mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#7c875a]" />
            Retningslinjer
          </div>
          <h1 className="font-serif text-[32px] sm:text-5xl font-bold text-[#1b3a4b] tracking-tight">
            Afbudspolitik
          </h1>
          <p className="mt-3 text-base sm:text-lg text-[#64748B] max-w-xl mx-auto">
            Regler vedrørende aflysning, ændring af aftaler og udeblivelse
          </p>
        </div>
      </section>

      {/* Policy Content */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 space-y-8">
          <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-sm border border-[#E5E0D8] space-y-6">
            <ul className="space-y-4 text-sm sm:text-base text-[#334155] leading-relaxed">
              <li className="flex items-start gap-3 p-4 rounded-xl bg-[#FAF8F5] border border-[#E5E0D8]">
                <i className="fa-solid fa-clock text-[#7c875a] mt-1" aria-hidden="true" />
                <span>
                  <strong>Meld afbud så tidligt som muligt, og senest kl. 8 dagen før aftalt tid.</strong>
                </span>
              </li>
              <li className="flex items-start gap-3 p-4 rounded-xl bg-[#FAF8F5] border border-[#E5E0D8]">
                <i className="fa-solid fa-triangle-exclamation text-[#7c875a] mt-1" aria-hidden="true" />
                <span>
                  Ved afbud senere, og ved udeblivelse, betales fuld pris.
                </span>
              </li>
              <li className="flex items-start gap-3 p-4 rounded-xl bg-[#FAF8F5] border border-[#E5E0D8]">
                <i className="fa-solid fa-hourglass-half text-[#7c875a] mt-1" aria-hidden="true" />
                <span>
                  Kommer du for sent til en behandling, vil jeg gøre alt for at hjælpe dig bedst muligt inden for den resterende tid. Der betales fuld pris.
                </span>
              </li>
            </ul>

            <div className="pt-6 border-t border-[#E5E0D8] space-y-4 text-sm text-[#475569] leading-relaxed">
              <h3 className="font-serif text-xl font-bold text-[#1b3a4b]">
                Sådan afbestiller du din tid
              </h3>
              <p>
                Du afbestiller din tid ved at gå ind i bookingsystemet på{' '}
                <a
                  href="https://system.easypractice.net/book/bosteendahl"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium text-[#1b3a4b] underline hover:text-[#7c875a]"
                >
                  system.easypractice.net/book/bosteendahl
                </a>{' '}
                og klikke på <strong>Login</strong>, øverst på siden.
              </p>
              <p>
                I venstre side under 'JEG ER ALLEREDE OPRETTET' klikker du på Login, hvorefter du får mulighed for at logge ind vha. dit Mobilnr. eller Mailadresse, eller med Facebook. Efter du er logget ind skal du trykke på <strong>'Anmod om aflysning'</strong>.
              </p>

              {/* OBS Boks */}
              <div className="p-6 rounded-2xl bg-amber-50 border border-amber-200/80 text-amber-900 space-y-2">
                <div className="flex items-center gap-2 font-bold text-sm text-amber-950">
                  <i className="fa-solid fa-circle-exclamation text-amber-600" aria-hidden="true" />
                  <span>OBS! Mindre end 24 timer til aftalt tid:</span>
                </div>
                <p className="text-xs sm:text-sm leading-relaxed">
                  Hvis der er mindre end 24 timer til den aftalte behandling kan der ikke anmodes om aflysning i systemet. I stedet sendes en sms på{' '}
                  <span className="font-semibold whitespace-nowrap">52 51 62 92</span> eller en mail på{' '}
                  <a
                    href="mailto:bs@bosteendahl.dk?subject=Aflysning"
                    className="font-semibold underline whitespace-nowrap"
                  >
                    bs@bosteendahl.dk
                  </a>.
                </p>
              </div>

              <p className="text-xs text-[#64748B] italic pt-2">
                Det er ikke muligt at ændre en tid i systemet – I stedet ’Anmodes om aflysning’ af den aftalte tid, og en ny tid bookes.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
